import { http } from '@ck/lib.http';

import { LocalConfig } from './types';

/**
 * The local config data
 */
export const appConfig: LocalConfig = {};

/**
 * This helper will look at the app config to know if the app is running live in dev mode
 * and if so, it will transform a given URL to load from localhost.
 * @param {string} url The relative URL
 * @returns The appropriate URL for the current environment
 */
export function urlHelper(url: string) {
  if (appConfig.mode === 'local-dev') return `https://atlaslocal.io:8443${url}`;
  return url;
}

async function load() {
  if (process.env.NODE_ENV === 'test') return;

  const response = await http<LocalConfig>('/config.json');
  Object.assign(appConfig, response.data);

  try {
    const override = await http<LocalConfig>('/overrides.json');
    Object.assign(appConfig, override.data);
  } catch (e) {
    // no-op
  }

  if (appConfig.dashboardAPIHost?.startsWith(':')) {
    appConfig.dashboardAPIHost = `${location.protocol}//${location.hostname}${appConfig.dashboardAPIHost}`;
  }
  return appConfig;
}

/**
 * A Promise that will resolve once the app config has been loaded
 */
export const loaded = load();
